import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { toIdString } from '../../utils/common';

export default class UserInviteSuccess extends React.Component {
  static propTypes = {
    closeFunction: PropTypes.func.isRequired,
    firstName: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    lastName: PropTypes.string.isRequired,
    submitFunction: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = params => {
    const { submitFunction } = this.props;
    submitFunction(params);
  };

  renderCheckbox = ({ label, type, input }) => (
    <div className="checkbox">
      <label htmlFor={toIdString(label)}>
        <input id={toIdString(label)} type={type} value="" {...input} />
        <i>
          <small>{label}</small>
        </i>
      </label>
    </div>
  );

  render() {
    const { firstName, handleSubmit, lastName } = this.props;

    return (
      <div className="container">
        <fieldset>
          <Form onSubmit={handleSubmit(this.submit)}>
            <p>
              An email has been sent to {firstName} {lastName}&nbsp; inviting them to join your
              company on Datarista.
            </p>
            <Field
              name="noNotification"
              type="checkbox"
              component={this.renderCheckbox}
              label="Please do not notify me about invitation emails in the future"
            />
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">
                Got it
              </button>
            </div>
          </Form>
        </fieldset>
      </div>
    );
  }
}
